export default "__VITE_ASSET__SBNovsjM__"